// src/components/ProtectedRoute.js
import { Navigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import AppSpinner from "../commons/AppSpinner";

const ProtectedRoute = ({ children, role }) => {
    const { user, initializing } = useAuth();

    
  if (initializing) {
    return  <AppSpinner size="sm" color="currentColor" />; // or a spinner
  }

  if (!user) {
    return <Navigate to="/login" />;
  }

  if (role && user.role !== role) {
    return <Navigate to="/" />;
  }

  return children;
};

export default ProtectedRoute;
